export const CONTAINERS_IMAGES_PAGE_LENGTH = 20;
export const CONTAINERS_IMAGE_TAGS_PAGE_LENGTH = 10;
export const CONTAINERS_RESOURCE_EXPIRY = 60 * 1000 * 1;

export const SORT_QUERY_PARAM = 'sort';
export const PAGE_QUERY_PARAM = 'page';
export const PAGELEN_QUERY_PARAM = 'pagelen';
export const SEARCH_IMAGE_NAME_QUERY_PARAM = 'name';
export const SEARCH_TAG_NAME_QUERY_PARAM = 'tagName';

export const REGISTRY_HOSTNAME = 'crg.apkg.io';
